import { Component, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { DialogService, TreeNode, MenuItem } from 'primeng/api';
import { Subject } from 'rxjs/Subject';
import { IPaginatedTable } from 'src/app/Interfaces/IPaginatedTable'
import { PaginatedTable } from 'src/app/Components/PaginatedTable/PaginatedTable'
import 'rxjs/add/operator/debounceTime';
import { environment } from 'src/environments/environment';
import { state, trigger, style, transition, animate } from '@angular/animations';
import { Indicator } from 'src/app/Models/Indicator'
import { Periodicity } from 'src/app/Models/Handbooks/Periodicity';
import { Activity } from 'src/app/Models/Handbooks/Activity';
import { Industry } from 'src/app/Models/Industry';
import { ReformatIndustry } from '../List/Helpers';
import { FactorsListComponent } from '../List/FactorsList';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CurrentLangPipe } from 'src/app/Pipes/CurrentLangPipe';
import { TranslatePipe } from 'src/app/Pipes/TranslatePipe';

@Component({
    selector: 'app-indicators-periodicity-list',
    templateUrl: './IndicatorsPeriodicityList.html',
    styleUrls: [],
    providers: [DialogService, CurrentLangPipe, TranslatePipe],
    animations: [
        trigger('rowExpansionTrigger', [
            state('void', style({
                transform: 'translateX(-10%)',
                opacity: 0
            })),
            state('active', style({
                transform: 'translateX(0)',
                opacity: 1
            })),
            transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class IndicatorsPeriodicityListComponent extends PaginatedTable<Indicator> implements OnInit, IPaginatedTable<Indicator> {

    PeriodicityId: number = this.route.snapshot.params.PeriodicityId;
    intryPeriodicity() {
        return this.http.get(`${environment.apiUrl}/api/Periodicities/Get/${this.route.snapshot.params.PeriodicityId}`, {
            headers: { "Content-Type": "application/json" }
        });
    }
    Periodicity: Periodicity = new Periodicity();
    importButtons: MenuItem[] = [
        {label: this.translatePipe.transform('actions.importFromCSV'), icon: 'fas fa-file-csv', command: () => {
            // command goes here
        }},
    ];
    getData() {
        this.isLoading = true;
        return this.http.get(`${environment.apiUrl}/api/Indicators/Paged?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&filter=${this.filters}&sort=${this.sorts}`, {
            headers: {
                "Content-Type": "application/json",
            }
        });
    }

    CurrentLang: string = 'ru';

    getActivities() {
        return this.http.get(`${environment.apiUrl}/api/Activities/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }

    getIndustries() {
        return this.http.get(`${environment.apiUrl}/api/Industries/Tree`, {
            headers: { "Content-Type": "application/json" }
        });
    }

    afterPaginate() {
        this.setData(() => {
            this.isLoading = false;
        });
    }

    Name: string = '';
    NameChanged: Subject<string> = new Subject<string>();
    NameChangedCall(text: string) { this.NameChanged.next(text); }

    TaldauIdentifier: string = '';
    TaldauIdentifierChanged: Subject<string> = new Subject<string>();
    TaldauIdentifierChangedCall(text: string) { this.TaldauIdentifierChanged.next(text); }

    ActivityId: string = '';
    ActivityIdChanged: Subject<string> = new Subject<string>();
    ActivityIdChangedCall(text: string) {
        this.IndustriesSelectedNodes = [];
        this.ActivityIdChanged.next(text);
    }
    Activities: Activity[] = [];
    get ActivitiesOptions(): Array<any> {
        return this.Activities.map((x) => ({
            label: (this.CurrentLang == 'ru')
                ? x.NameRu
                : (this.CurrentLang == 'kk')
                    ? x.NameKz
                    : x.NameEn,
            value: x.Id
        }))
    }

    get IndustryId(): string {
        return this.IndustriesSelectedNodes.map(x => x.data).join(',');
    };
    Industries: Array<Industry> = [];
    IndustriesSelectedNodes: TreeNode[] = [];
    IndustriesTree: TreeNode[] = [];
    IndustriesTreeForSphere: TreeNode[] = [];
    DeselectIndustries() {
        this.IndustriesSelectedNodes = [];
        this.filtersChanged();
    }
    IndustriesChanged() {
        this.ActivityId = '';
        this.filtersChanged();
    }
    
    public MakeUlIndustry(industry: Industry): string[] {
        return [
            industry.Name,
            ...(industry.Parent != null ? this.MakeUlIndustry(industry.Parent) : [])
        ]
    }

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public dialogService: DialogService,
        private currentLangPipe: CurrentLangPipe,
        private translatePipe: TranslatePipe,
        // private cookieService: CookieService
    ) {
        super();
        this.router.events.forEach(x => {
            if(x instanceof NavigationEnd) {
                this.PeriodicityId = this.route.snapshot.params.PeriodicityId;

                this.intryPeriodicity().subscribe((x: Periodicity) => {
            
                    this.Periodicity = x;
                    this.filters = this.nameSelectionOnLang()
                        + `|TaldauIdentifier:${this.TaldauIdentifier}`
                        + `|PeriodicityId:${this.PeriodicityId}`
                        + `|ActivityId:${this.ActivityId}`
                        + `|IndustryId:${this.IndustryId}`
        
                    this.getActivities().subscribe((data: Array<Activity>) => {
                        this.Activities = data
                    })
                    this.getIndustries().subscribe((data: Array<Industry>) => {
                        var lang = this.currentLangPipe.get()
                        this.Industries = data;
                        this.IndustriesTree = this.Industries.map(x => ReformatIndustry(x, lang))
                        this.IndustriesTreeForSphere = this.Industries.map(x => ReformatIndustry(x, lang, true));
                        this.IndustriesTreeForSphere = this.IndustriesTreeForSphere.map(x => {var _s = x; _s.selectable = false; return _s;});
                    })
                    
                    this.NameChanged.debounceTime(700).subscribe(model => { this.Name = model; this.filtersChanged() });
                    this.TaldauIdentifierChanged.debounceTime(700).subscribe(model => { this.TaldauIdentifier = model; this.filtersChanged() });
                    this.ActivityIdChanged.debounceTime(700).subscribe(model => { this.ActivityId = model; this.filtersChanged() });

                    this.setData();
                })
            }
        })
        
        
    }

    ngOnInit() {
        this.CurrentLang = this.currentLangPipe.get();
        this.filters = this.nameSelectionOnLang()
            + `|TaldauIdentifier:${this.TaldauIdentifier}`
            + `|PeriodicityId:${this.PeriodicityId}`
            + `|ActivityId:${this.ActivityId}`
            + `|IndustryId:${this.IndustryId}`
        this.setData();
    }

    nameSelectionOnLang() {
        switch (this.CurrentLang) {
            case 'kk': { return 'NameKz:' + this.Name; }
            case 'en': { return 'NameEn:' + this.Name; }
            case 'ru':
            default: { return 'NameRu:' + this.Name; }
        }
    }

    filtersChanged() {
        this.filters = this.nameSelectionOnLang()
            + `|TaldauIdentifier:${this.TaldauIdentifier}`
            + `|PeriodicityId:${this.PeriodicityId}`
            + `|ActivityId:${this.ActivityId}`
            + `|IndustryId:${this.IndustryId}`
        
        //this.sorts = `NameRu:true`
        this.setData(() => {
            this.isLoading = false;
        })
    }

    showFactorsDialogue(row: Indicator) {
        const ref = this.dialogService.open(FactorsListComponent, {
            data: { Indicator: row },
            header: this.translatePipe.transform('indicators.listOfFactorsForSelectedIndicator'),
            width: '70%',
            contentStyle: {
                'padding-bottom': '14px',
                'padding-top': '14px'
            }
        });
    }

}